import { Pushable, pushableEventOfPure } from "./pushable";
import { GuidedSellingExternalState } from "../../components/GuidedSellingComponent/state/state";
import { useEffect } from "react";
import { useSyncedEqualState } from "../../hooks/use-synced-equal-state";

export type GuidedSellingEvent =
  | {
      event: `guided-selling-screen`;
      selection: string | undefined;
      screenIdx: number;
    }
  | {
      event: "guided-selling-finished";
    }
  | {
      event: "guided-selling-result-pdp";
      data: string;
    }
  | {
      event: "guided-selling-result-comparison";
      data: string;
    };

export const guidedSellingTrackingAspect = {
  guidedSellingScreenIdx: (selection: string | undefined, screenIdx: number): Pushable => {
    return pushableEventOfPure({
      event: `guided-selling-screen`,
      selection,
      screenIdx,
    });
  },
  guidedSellingFinished: (): Pushable => {
    return pushableEventOfPure({
      event: "guided-selling-finished",
    });
  },
  guidedSellingResultPdp: (data: string): Pushable => {
    return pushableEventOfPure({
      event: "guided-selling-result-pdp",
      data: data,
    });
  },
  guidedSellingResultComparison: (data: string): Pushable => {
    return pushableEventOfPure({
      event: "guided-selling-result-comparison",
      data: data,
    });
  },
};

export function useGuidedSellingAnalytics(state: GuidedSellingExternalState) {
  const equalState = useSyncedEqualState(state);

  useEffect(() => {
    if (equalState.tag === "choices") {
      guidedSellingTrackingAspect
        .guidedSellingScreenIdx(equalState.data.selected, equalState.data.currentStepIdx)
        .push();
    } else if (equalState.tag === "results" && equalState.data.results.__tag === "loaded") {
      guidedSellingTrackingAspect.guidedSellingFinished().push();
    }
  }, [equalState]);
}
